import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams, Navigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table, Spinner } from 'reactstrap';
import UiContent from '../../../../Components/Common/UiContent';

import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';
import FuelSupplyMonth from './Widgets/FuelSupplyMonth';

function LoadingWrapper({ isLoading, children }) {
  return isLoading ? (
    <OPlaceholder />
  ) : (
    children
  );
}

const FuelSupplyPanel = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("cp");

  const selectorEstablishment = createSelector(
    state => state.Establishments,
    result => ({
      establishment: result.itemEstablishmentDetail,
      isLoading: result.isLoadingList
    })
  );

  const { establishment, isLoading } = useSelector(selectorEstablishment);

  useEffect(() => {
    if (id) {
    }
  }, [id]);


  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content mb-10" style={{ paddingBottom: '90px' }}>
        <Container fluid>
          <Row className="layout-dashboard" style={{ height: "100vh" }}>
            <Col md={6} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Row>
                <Col md={12}>
                  <FuelSupplyMonth title={"Combustible por mes"} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>

                </Col>
              </Row>
              <Row>
                <Col md={12}>

                </Col>
              </Row>
            </Col>

            <Col md={8} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Row>
                <Col md={12}>

                </Col>
              </Row>
              <Row style={{ flex: 1 }}>
                <Col md={12} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                  <Row style={{ flex: 1 }}>
                    <Col md={8} style={{ height: "100%" }}>

                    </Col>
                    <Col md={4} style={{ height: "100%" }}>

                    </Col>
                  </Row>
                  <Row style={{ flex: 1 }}>
                    <Col md={8} style={{ height: "100%" }}>

                    </Col>
                    <Col md={4} style={{ height: "100%" }}>

                    </Col>
                  </Row>
                  <Row style={{ flex: 1 }}>
                    <Col md={5} style={{ height: "100%" }}>

                    </Col>
                    <Col md={3}>

                    </Col>
                    <Col md={4} style={{ height: "100%" }}>

                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

 
          </Row>
        </Container>
      </div>
    </React.Fragment>

  );
};

export default FuelSupplyPanel;
